module.exports = __webpack_public_path__ + "media/images/img-upload-06b21469cea6b48d30ddedd34769097b.svg";